import React, { useEffect, useState } from 'react'
import { useTheme } from '@/context/ThemeContext'
import { Sidebar } from '@/components/ui/sidebar'
import Header from '@/components/ui/header'
import BottomNav from '@/components/ui/bottom-nav'
import { getMyWorkspaces, type WorkspaceSummary } from '@/features/onboarding/services/workspaceApi'
import CampaignDetailSection from '@/features/campaigns/components/CampaignDetailSection'

export const CampaignDetailPage: React.FC = () => {
  const { currentTheme } = useTheme()
  const [workspace, setWorkspace] = useState<WorkspaceSummary | null>(null)

  useEffect(() => {
    getMyWorkspaces().then((ws) => { if (ws[0]) setWorkspace(ws[0]) }).catch(() => {})
  }, [])

  return (
    <div className="h-full flex flex-col overflow-hidden transition-colors duration-300" style={{ backgroundColor: currentTheme.primary }}>
      <div className="flex flex-1 min-h-0 overflow-hidden pb-16 md:pb-0">
        <Sidebar />
        <div className="flex-1 flex flex-col overflow-hidden">
          <Header title="Campaign" backTo="/dashboard/sales?tab=campaigns" />
          <main className="flex-1 min-h-0 overflow-y-auto custom-scrollbar p-4 md:p-6">
            <div className="max-w-[900px] mx-auto">
              {workspace ? <CampaignDetailSection workspaceId={workspace.id} workspaceRole={workspace.role} /> : null}
            </div>
          </main>
        </div>
      </div>
      <BottomNav />
    </div>
  )
}

export default CampaignDetailPage
